import styles from './Title.module.css';

export function Title() {
    return <p className={styles.title}>Team</p>;
}
